import { render } from "./chat-content.vue?vue&type=template&id=3c0d7fac&scoped=true"
import script from "./chat-content.vue?vue&type=script&lang=js"
export * from "./chat-content.vue?vue&type=script&lang=js"

import "./chat-content.vue?vue&type=style&index=0&id=3c0d7fac&lang=scss"
import "./chat-content.vue?vue&type=style&index=1&id=3c0d7fac&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0d7fac"]])

export default __exports__